module.exports = {
      id: "shortform-usage",
      viewBox: "0 0 13.07 13.758",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#shortform",
      toString: function () {
        return this.url;
      }
    }